import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {includes} from 'lodash';
import {FC, MouseEvent, useState} from 'react';
import {useRecoilValue} from 'recoil';
import {ICompany} from '../../../../shared/types/company.types';
import {companySelectedIdsSelector} from '../../../../store/company/selectors';
import DeleteCompany from '../DeleteCompany/DeleteCompany';

interface Props {
  row: ICompany;
}

const DeleteCell: FC<Props> = ({row}) => {
  const selected = useRecoilValue(companySelectedIdsSelector);
  const isSelected = includes(selected, row.id);
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpenDelete = (e: MouseEvent<unknown>) => {
    e.stopPropagation();
    setOpenDelete(true);
  };

  const handleCloseDelete = () => setOpenDelete(false);

  return (
    <>
      <Box>
        <Tooltip title="Удалить">
          <IconButton disabled={!isSelected} onClick={handleOpenDelete}>
            <DeleteForeverIcon color={isSelected ? 'error' : 'disabled'} />
          </IconButton>
        </Tooltip>
      </Box>

      {openDelete && <DeleteCompany open={openDelete} company={row} handleClose={handleCloseDelete} />}
    </>
  );
};

export default DeleteCell;
